enum GridName {
  PRODUCTION = "PRODUCTION",
  OVERVIEW = "OVERVIEW",
}
export default GridName;
